import axios from "axios";
import { handleRefreshToken } from "./refreshToken";

const api = axios.create({
  baseURL: "https://backend.drnabtah.com/api",
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Accept"] = "application/json";
    config.headers["device-type"] = "web";
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      return handleRefreshToken(error, originalRequest, api);
    }

    return Promise.reject(error);
  }
);

export default api;
